import axios from "axios";
import { getURL } from "../constants/index.js";
import store from "../redux/store";
import { genericRequest } from "./genericRequest.js";

export async function getSpChkTemp(serialNumber) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url:
        WebAPI_URL +
        "Hygeian/api/Instrument/GetCachedSpotCheckTemp/" +
        serialNumber,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getSpChkInstruments(entid) {
  return await genericRequest('GET', 
    "Hygeian/api/Instrument/GetDeployedSpotCheckInstrument/" + entid);
  // const WebAPI_URL = getURL();
  // const state = store.getState();
  // if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  // const token = state.authReducer.user.profile.token;
  // return new Promise((resolve, reject) => {
  //   const config = {
  //     method: "GET",
  //     url:
  //       WebAPI_URL +
  //       "Hygeian/api/Instrument/GetDeployedSpotCheckInstrument/" +
  //       entid,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "*/*",
  //       Authorization: "Bearer " + token,
  //     },
  //   };
  //   axios(config)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         resolve(response);
  //       }
  //       reject(response);
  //     })
  //     .catch((error) => {
  //       reject(error);
  //     });
  // });
}

export async function getInstrumentList(allInstrument = false) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url:
        WebAPI_URL + "Hygeian/api/Instrument/GetInstruments/" + allInstrument,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getInstrumentDeployment(category) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url:
        WebAPI_URL +
        "Hygeian/api/Instrument/GetInstrumentsDeployment/" +
        category,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getInstrumentDeploy(InstrumentId) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url:
        WebAPI_URL +
        "Hygeian/api/Instrument/GetInstrumentDeployment/" +
        InstrumentId,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getInstrumentListByCategory(
  category,
  allInstrument = false
) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url:
        WebAPI_URL +
        "Hygeian/api/Instrument/GetInstruments/" +
        category +
        "?allInstruments=" +
        allInstrument,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getInstrumentTypes() {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url: WebAPI_URL + "Hygeian/api/InstrumentType/GetCurrentInstrumentTypes",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getUncalibratedInstrument() {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url: WebAPI_URL + "Hygeian/api/Instrument/GetUncalibratedInstruments",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function updateInstrumentCalibration(event) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "POST",
      url: WebAPI_URL + "Hygeian/api/Instrument/UpdateInstrument",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      data: JSON.stringify(updateInstrurment(event)),
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function updateInstrumentService(event) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  //console.log(event);
  return new Promise((resolve, reject) => {
    const config = {
      method: "POST",
      url: WebAPI_URL + "Hygeian/api/Instrument/UpdateInstrument",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      data: JSON.stringify(updateInstrurment(event)),
    };
    axios(config)
      .then((response) => {
        //console.log("response", response);
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function insertInstrument(event) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "POST",
      url: WebAPI_URL + "Hygeian/api/Instrument/PostInstrumentSetup",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      data: JSON.stringify(updateInstrurment(event)),
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateInstrurment(event) {
  //console.log("updateInstrurment", event);
  //event.status = "Current";
  event.entid = event.enterprise.entid1;
  event.siteid = event.site.siteid1;
  event.locid = event.location.locid1;
  return event;
}

export async function updateService(event, instrumentSerialNumber) {
  //console.log("updateService", event, instrumentSerialNumber);
  event.data.map((item) => {
    //if (
    //item.instrumentDetail.instrumentSerialNumber == instrumentSerialNumber
    //) {
    item.expanded = true;
    return item;
    //}
  });
  return event;
}

export async function batteryParametersService(event) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "POST",
      url: WebAPI_URL + "Hygeian/api/Instrument/BatteryParameter",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      data: JSON.stringify(event),
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function updateTemperatureChartParametersService(event) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null) window.location.href = "/auth/sign-in";
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "POST",
      url:
        WebAPI_URL + "Hygeian/api/Instrument/UpdateTemperatureChartParameters",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      data: JSON.stringify(event),
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
